'use client';

import { Viewport } from '@/theme/breakpoints';
// TEMP diagnostic — mobile-chat drag re-render / double-mount. Remove with mobile-drag-rerender-probe.ts.
import {
  useMobileDragRerenderLogger,
  useMountUnmountProbe,
  useRenderStormProbe,
} from '@/hooks/telemetry/mobile-drag-rerender-probe';

const CPAGELAYOUT_MOBILE_DRAG_COMPONENT = 'Cpagelayout';
const CPAGELAYOUT_NULL_SNAPSHOT_VALUE = 'null';

interface UseCpagelayoutRenderDiagnosticsInput {
  isMobile: boolean;
  pathname: string | null;
  ready: boolean;
  vh: number;
  viewport: Viewport | null | undefined;
}

export function useCpagelayoutRenderDiagnostics({
  isMobile,
  pathname,
  ready,
  vh,
  viewport,
}: UseCpagelayoutRenderDiagnosticsInput): void {
  // TEMP diagnostic — double-mount localization between route runtime and the
  // session page. Remove with mobile-drag-rerender-probe.ts.
  const mobileDragRerenderLog = useMobileDragRerenderLogger(CPAGELAYOUT_MOBILE_DRAG_COMPONENT);
  useMountUnmountProbe({ logger: mobileDragRerenderLog, label: CPAGELAYOUT_MOBILE_DRAG_COMPONENT });
  // TEMP diagnostic — if Cpagelayout also no-op-cascades in sync with
  // Csessionpage, the driver is a context provider ABOVE it. Remove with
  // mobile-drag-rerender-probe.ts.
  useRenderStormProbe({
    logger: mobileDragRerenderLog,
    component: CPAGELAYOUT_MOBILE_DRAG_COMPONENT,
    snapshot: {
      viewport: viewport ?? CPAGELAYOUT_NULL_SNAPSHOT_VALUE,
      isMobile,
      ready,
      viewportHeightVh: vh,
      pathname: pathname ?? CPAGELAYOUT_NULL_SNAPSHOT_VALUE,
    },
  });
}
